export default function SkiftPersonartIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height * (29 / 16.859) : 29}
      height={height ? height : width ? width * (16.859 / 29) : 16.859}
      viewBox="0 0 29 16.859"
    >
      <g fill="currentColor">
        <g fill="currentColor">
          <path d="M22.49 0a3.606 3.606 0 1 1-3.606 3.606A3.61 3.61 0 0 1 22.49 0Zm0 5.811a2.206 2.206 0 1 0-2.206-2.205 2.208 2.208 0 0 0 2.206 2.205Z" />
          <path d="M28.3 16.857H16.678a.7.7 0 0 1-.7-.7v-1.289a6.518 6.518 0 0 1 6.511-6.511 6.705 6.705 0 0 1 4.139 1.485 6.382 6.382 0 0 1 2.373 5.026v1.289a.7.7 0 0 1-.701.7Zm-10.922-1.4H27.6v-.591a4.941 4.941 0 0 0-1.807-3.9h-.006a5.29 5.29 0 0 0-3.3-1.2 5.117 5.117 0 0 0-5.109 5.102Z" />
        </g>
        <g opacity="0.5">
          <g>
            <path d="M12.554 13.363h-6a.7.7 0 0 1-.7-.7.7.7 0 0 1 .7-.7h6a.7.7 0 0 1 .7.7.7.7 0 0 1-.7.7Z" />
            <path d="M11.444 15.583a.7.7 0 0 1-.494-1.193l1.723-1.725-1.725-1.729a.7.7 0 0 1 .992-.988l2.219 2.223a.7.7 0 0 1 0 .988l-2.219 2.219a.7.7 0 0 1-.496.205Z" />
          </g>
          <path d="M8.49 16.859H.742a.7.7 0 0 1-.7-.636 7.646 7.646 0 0 1 1.085-5.014 6.414 6.414 0 0 1 2.815-2.354 6.912 6.912 0 0 1 4.48-.288.7.7 0 0 1-.306 1.366 5.532 5.532 0 0 0-3.626.208 5.225 5.225 0 0 0-3.088 5.318H8.49a.7.7 0 1 1 0 1.4Z" />
          <path d="M6.554 0a3.606 3.606 0 1 1-3.606 3.606A3.61 3.61 0 0 1 6.554 0Zm0 5.811a2.206 2.206 0 1 0-2.206-2.205 2.208 2.208 0 0 0 2.206 2.205Z" />
        </g>
      </g>
    </svg>
  );
}
